export default "__VITE_ASSET__0raDxh0f__"